import React, { useEffect, useState } from 'react';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 47
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  const Box = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-201">
      <motion.div key={value} initial={{
      opacity: 0.65
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.25
    }} className="bg-[#D32F2F] text-white rounded-xl px-3 py-2 min-w-[64px] text-center shadow-md tabular-nums" data-id="element-202">
        {format(value)}
      </motion.div>
      <span className="text-xs text-current opacity-70 mt-1 uppercase tracking-wider font-sans font-semibold" data-id="element-203">
        {label}
      </span>
    </div>;
  return <div className="inline-flex items-center justify-center gap-2 text-2xl md:text-4xl font-display font-bold my-4" data-id="element-204">
      <Box value={timeLeft.hours} label="hs" data-id="element-205" />
      <span className="text-[#D32F2F] pb-5" data-id="element-206">:</span>
      <Box value={timeLeft.minutes} label="min" data-id="element-207" />
      <span className="text-[#D32F2F] pb-5" data-id="element-208">:</span>
      <Box value={timeLeft.seconds} label="seg" data-id="element-209" />
    </div>;
}
export function TrustBar({
  tone = 'light'
}: {
  tone?: 'light' | 'dark';
}) {
  return <div className={`flex flex-wrap justify-center gap-4 text-sm font-medium mt-4 ${tone === 'dark' ? 'text-gray-300' : 'text-brand-gray'}`} data-id="element-210">
      <div className="flex items-center gap-1.5" data-id="element-211">
        <ShieldCheck className="w-4 h-4" data-id="element-212" /> Garantía 7 días
      </div>
      <div className="flex items-center gap-1.5" data-id="element-213">
        <Lock className="w-4 h-4" data-id="element-214" /> Pago seguro
      </div>
      <div className="flex items-center gap-1.5" data-id="element-215">
        <CreditCard className="w-4 h-4" data-id="element-216" /> Mercado Pago
      </div>
    </div>;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'primary' | 'success';
}) {
  const baseClass = 'w-full py-4 px-6 rounded-2xl font-display font-bold text-lg md:text-xl text-white text-center transition-all active:scale-95 flex justify-center items-center gap-2';
  const variants = {
    primary: 'bg-gradient-to-b from-[#FB8C00] to-[#EF6C00] hover:from-[#FF9800] hover:to-[#F57C00] shadow-[0_8px_20px_rgba(245,124,0,0.35)] border border-[#FF9800]/40',
    success: 'bg-gradient-to-b from-[#388E3C] to-[#2E7D32] hover:from-[#43A047] hover:to-[#338A3E] shadow-[0_8px_20px_rgba(46,125,50,0.3)] border border-[#43A047]/40'
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={`${baseClass} ${variants[variant]} ${className}`} data-id="element-217">
        {children}
      </a>;
  }
  return <button onClick={onClick || (() => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  })} className={`${baseClass} ${variants[variant]} ${className}`} data-id="element-218">
      {children}
    </button>;
}
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return;
}